// import { getFeedUrl } from 'helpers/feeds/generalHelpers';
import _get from 'lodash.get';
import reducerRegistry from 'reduxUtils/reducerRegistry';
import makeRequest from 'utils/makeRequest';
// import { getMsidFromPath } from 'utils/common';
import {
  // CARDS_ARTICLESHOW_JSON_URL,
  // TOI_PLUS_PLAN_TRANSLATION_MWEB,
  // TOI_PLUS_PLAN_TRANSLATION_WEB,
  CARDS_TOPIC_TREE_STORY_BUNDLE_JSON_URL,
  // CARDS_TOPIC_TREE_JSON_URL,
  // PERSONALIZE_UP_NEXT_V2_API,
  // SIGNAL_PARAMETER,
  SUBSCRIPTION_LINKING_DOMAIN_GOOGLE,
} from 'constants/index.js';
// import { appendGrxParams } from 'utils/common';

const reducerName = 'toiplusprimeshow';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_PRIMESHOW_DATA = createActionName(
  'RECEIVE_PRIMESHOW_DATA',
);
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');
export const PERPETUAL_DATA = createActionName('PERPETUAL_DATA');
export const ACTIVE_MSID = createActionName('ACTIVE_MSID');
export const PRIMESHOW_DATA_LOADING = createActionName(
  'PRIMESHOW_DATA_LOADING',
);
export const PRIMESHOW_DATA_LOADED = createActionName('PRIMESHOW_DATA_LOADED');
export const RECIEVE_PRIMESHOW_BUNDLE_HASHTAG_DATA = createActionName(
  'RECIEVE_PRIMESHOW_BUNDLE_HASHTAG_DATA',
);

export const RECEIVE_RHS_STORIES_DATA = createActionName(
  'RECEIVE_RHS_STORIES_DATA',
);

// action creators
export function receivePrimeshowData(data) {
  return {
    type: RECEIVE_PRIMESHOW_DATA,
    payload: {
      data,
      msid: data.id,
    },
  };
}

// function handleArticleshowDataError(error) {
//   return {
//     type: HANDLE_DATA_ERROR,
//     error,
//   };
// }

export function primeshowDataLoading() {
  return {
    type: PRIMESHOW_DATA_LOADING,
    payload: {},
  };
}
export function recieveperpetualData(perpetualCardsData) {
  return {
    type: PERPETUAL_DATA,
    payload: perpetualCardsData,
  };
}

export function primeshowDataLoaded() {
  return {
    type: PRIMESHOW_DATA_LOADED,
    payload: {},
  };
}

export function receivePrimeshowBundleHashtag(data) {
  return {
    type: RECIEVE_PRIMESHOW_BUNDLE_HASHTAG_DATA,
    payload: data,
  };
}

export function receiveRHSStoriesData(data) {
  return {
    type: RECEIVE_RHS_STORIES_DATA,
    payload: data,
  };
}

//data gatherers
// function fetchArticleshowData(params, isAppView) {
//   const appParameter = isAppView ? '&frmapp=yes' : '';
//   // this code is temporary
//   const primeuser = params.frmprime === 'yes' ? '&isprime=true' : '';
//   const isClientConsumable = params.isClientConsumable
//     ? '&test=consumable'
//     : '';
//   const isTestOutstream = params.isTestOutstream ? '&test=outstream' : '';
//   const isClientConsumableV2 = params.isClientConsumableV2
//     ? '&test=consumable_V2'
//     : '';
//   const articlePath = `/articleshow/${getMsidFromPath(params.fullPath)}.cms`;
//   const url = `${getFeedUrl()}/toi/web/show/news?version=v2&path=${articlePath}${appParameter}${isClientConsumable}${isTestOutstream}${isClientConsumableV2}${primeuser}`;
//   return makeRequest.get(url);
// }

//get Subscription link details
export const fetchSubscriptionLinkStatus = ({ isWapView, token }) => {
  const platform = isWapView ? 'mweb' : 'web';
  const headers = {
    // ssoId,
    // ticketId,
    'X-TOKEN': token,
  };
  const url = `${SUBSCRIPTION_LINKING_DOMAIN_GOOGLE}/subscription/TOI/TOIPLUS/google/web/linked`;
  return makeRequest.get(url, { headers });
};

//post Subscription initiation
export const postInitiateLinking = ({ isWapView, token }) => {
  const headers = {
    'Content-Type': 'application/json',
    // ssoId,
    // ticketId,
    'X-TOKEN': token,
  };
  const platform = isWapView ? 'mweb' : 'web';
  const url = `${SUBSCRIPTION_LINKING_DOMAIN_GOOGLE}/subscription/TOI/TOIPLUS/google/web/link`;
  return makeRequest.post(url, { isMobile: isWapView }, { headers });
};

//exposed functions
// export function loadArticleshowData(params, isAppView) {
//   return dispatch => {
//     dispatch(primeshowDataLoading());
//     return fetchArticleshowData(params, isAppView)
//       .then(data => {
//         dispatch(primeshowDataLoaded());
//         dispatch(receiveArticleshowData(data.data, params));
//       })
//       .catch(error => {
//         dispatch(primeshowDataLoaded());
//         dispatch(handleArticleshowDataError(error));
//       });
//   };
// }
export function updateActiveMsid(msid) {
  return {
    type: ACTIVE_MSID,
    payload: {
      activemsid: msid,
    },
  };
}

export function fetchBundleHashtag(topicUrl) {
  return makeRequest.get(
    `${CARDS_TOPIC_TREE_STORY_BUNDLE_JSON_URL}${topicUrl}.json`,
    'skipfeedengine',
  );
}

export function getBundleHashtag(topicUrl) {
  return dispatch =>
    fetchBundleHashtag(topicUrl).then(resp =>
      dispatch(receivePrimeshowBundleHashtag(resp.data)),
    );
}

// export function fetchRHSStoriesData({
//   code,
//   template,
//   user_prime_status,
//   article_prime_status,
//   mode,
//   limit,
// }) {
//   const PERSONALIZE_UP_NEXT_V2 = appendGrxParams(PERSONALIZE_UP_NEXT_V2_API);
//   return makeRequest.get(
//     `${PERSONALIZE_UP_NEXT_V2}rhsdata&code=${code}&template=${template}&user_prime_status=${user_prime_status}&article_prime_status=${article_prime_status}&mode=${mode}&limit=${limit}${SIGNAL_PARAMETER}`,
//   );
// }

// export function getRHSStoriesData(params) {
//   const filterCards = cards => {
//     const _cards = [];
//     const _usedCards = [];
//     const _defaultFilterObj = cards?.filters?.[0]?.[cards?.default_filter];
//     let _hasSameAsMSID = false;

//     const filterData = item => {
//       if (
//         item &&
//         _defaultFilterObj?.indexOf(item.card_id) > -1 &&
//         _usedCards.indexOf(item.card_id) === -1 &&
//         ((_cards.length < params.limit - 1 && !_hasSameAsMSID) ||
//           _hasSameAsMSID)
//       ) {
//         if (item.id?.toString() === params.msid) {
//           _hasSameAsMSID = true;
//         } else {
//           _cards.push(item);
//           _usedCards.push(item.card_id);
//         }
//       }
//     };

//     if (cards?.cards?.length) {
//       cards.cards.forEach(filterData);
//     }
//     return _cards;
//   };

//   return dispatch =>
//     fetchRHSStoriesData(params).then(resp => {
//       const cards = filterCards(
//         resp?.data?.inserts?.['above-bottom-of-article'],
//       );
//       dispatch(receiveRHSStoriesData(cards));
//     });
// }

// reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case PRIMESHOW_DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case PRIMESHOW_DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }
    case PERPETUAL_DATA: {
      return {
        ...state,
        perpetualData: action.payload,
      };
    }
    case ACTIVE_MSID: {
      return {
        ...state,
        activeMsid: action.payload.activemsid,
      };
    }
    case RECEIVE_PRIMESHOW_DATA: {
      const articleShowData = state.data ? state.data : {};
      articleShowData[action.payload.msid] = action.payload.data;
      const articleData = articleShowData[action.payload.msid];
      const isCardCMS =
        _get(articleData, `metaInfo.CARDPAGETEMPLATE`) === 'cardhd';
      if (isCardCMS && articleData.ads) {
        articleData.ads = {};
      }

      articleShowData[action.payload.msid] = articleData;
      return {
        ...state,
        data: articleShowData,
      };
    }

    case RECIEVE_PRIMESHOW_BUNDLE_HASHTAG_DATA: {
      return {
        ...state,
        decode: action.payload.decode,
      };
    }
    case RECEIVE_RHS_STORIES_DATA: {
      return {
        ...state,
        RHSStories: action.payload,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
